import { render, staticRenderFns } from "./RegionRecap.vue?vue&type=template&id=7c2ee2c2"
import script from "./RegionRecap.vue?vue&type=script&lang=js"
export * from "./RegionRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports